import { render } from "./Construction.vue?vue&type=template&id=3ddf35bf&scoped=true"
import script from "./Construction.vue?vue&type=script&lang=js"
export * from "./Construction.vue?vue&type=script&lang=js"

import "./Construction.vue?vue&type=style&index=0&id=3ddf35bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddf35bf"]])

export default __exports__